import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/website/node_modules/@sanity/next-loader/dist/client-components/live-stream.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/website/node_modules/@sanity/next-loader/dist/client-components/live.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/website/node_modules/next-sanity/dist/visual-editing/client-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/website/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager", webpackExports: ["SanityContents"] */ "/vercel/path0/app/website/src/contents/SanityContents.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/app/website/src/modules/i18n/context.tsx");
